"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountMethod = exports.DiscountAvailabilityType = exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType[DiscountType["Percentage"] = 0] = "Percentage";
    DiscountType[DiscountType["Currency"] = 1] = "Currency";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var DiscountAvailabilityType;
(function (DiscountAvailabilityType) {
    DiscountAvailabilityType[DiscountAvailabilityType["None"] = 0] = "None";
    DiscountAvailabilityType[DiscountAvailabilityType["Pos"] = 1] = "Pos";
    DiscountAvailabilityType[DiscountAvailabilityType["Express"] = 2] = "Express";
    DiscountAvailabilityType[DiscountAvailabilityType["OrderApp"] = 4] = "OrderApp";
    DiscountAvailabilityType[DiscountAvailabilityType["OrderWeb"] = 8] = "OrderWeb";
    DiscountAvailabilityType[DiscountAvailabilityType["PrepaidWallet"] = 16] = "PrepaidWallet";
})(DiscountAvailabilityType = exports.DiscountAvailabilityType || (exports.DiscountAvailabilityType = {}));
var DiscountMethod;
(function (DiscountMethod) {
    DiscountMethod["ComoDiscount"] = "577589c1-ff96-4776-932e-08ddc07780bb";
})(DiscountMethod = exports.DiscountMethod || (exports.DiscountMethod = {}));
